import {Jurisdiction} from '../countries/constants'

export const tmRenewalJurisdictionsWithLandingPage = [
  Jurisdiction.UK,
  Jurisdiction.US,
  Jurisdiction.EU,
  Jurisdiction.AU,
  Jurisdiction.CH,
  Jurisdiction.NZ,
  Jurisdiction.SK,
  Jurisdiction.CZ,
  Jurisdiction.IE,
  Jurisdiction.FR,
  Jurisdiction.BX,
  Jurisdiction.CA,
  Jurisdiction.CN,
  Jurisdiction.JP,
  Jurisdiction.TR,
  Jurisdiction.BR,
]

export const tmRenewalJurisdictions = [
  ...tmRenewalJurisdictionsWithLandingPage,
  ...Object.values(Jurisdiction).filter(
    (jurisdiction) => !tmRenewalJurisdictionsWithLandingPage.includes(jurisdiction),
  ),
]

export const tmRenewalJurisdictionToHeroImage: Partial<Record<Jurisdiction, string>> = {
  [Jurisdiction.UK]: 'united-kingdom.svg',
  [Jurisdiction.US]: 'united-states.svg',
  [Jurisdiction.EU]: 'europe.svg',
  [Jurisdiction.AU]: 'australia.svg',
  [Jurisdiction.CH]: 'switzerland.svg',
  [Jurisdiction.NZ]: 'new-zealand.svg',
  [Jurisdiction.SK]: 'slovak-republic.svg',
  [Jurisdiction.CZ]: 'czech-republic.svg',
  [Jurisdiction.IE]: 'ireland.svg',
  [Jurisdiction.FR]: 'france.svg',
  [Jurisdiction.BX]: 'benelux.svg',
  [Jurisdiction.CA]: 'canada.svg',
  [Jurisdiction.CN]: 'china.svg',
  [Jurisdiction.JP]: 'japan.svg',
  [Jurisdiction.TR]: 'turkiye.svg',
  [Jurisdiction.BR]: 'brazil.svg',
}
